import React, { useEffect, useState } from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import Login from "../../login/components/Login";
import Loader from "./Loader";
import ForgotPassword from "../../login/components/ForgotPassword";
import SessionTimeOut from "./SessionTimeOut";
import VerifyUser from "../../login/components/VerifyUser";
import ResetPassword from "../../login/components/ResetPassword";
import { hideLoader, showLoader } from "../actions/commonActions";
import API from "../../helpers/API";
import { isLoaderApplicable } from "../../helpers/util";
import CriteriaEditor from "../../criteriaeditor/components/CriteriaEditor";
import OasdminContainer from "./oasdminContainer";
import ApplicationHeader from "../../common/components/ApplicationHeader";
import labels from "../../usermanagement/labels/users_en.json";
import ApplicationFooter from "./ApplicationFooter";


const AppLayout = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const handlePopState = () => {
      props.history.go(1);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [props.history]);

  useEffect(() => {
    API.interceptors.request.use(async (request) => {
      if (isLoaderApplicable(request.url)) {
        dispatch(showLoader());
      }
      return request;
    });

    API.interceptors.response.use(
      async (response) => {
        dispatch(hideLoader());
        return response;
      },
      async (error) => {
        dispatch(hideLoader());
        throw error;
      }
    );
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <ApplicationHeader
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        fullName={props.fullName}
        departmentId={props.deaprtmentId}
        roleId={props.roleId}
        labels={labels}
        userProps={props}
      />

      <div className="ContentContainer">
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/admin/login" component={Login} />
            <Route exact path="/admin/forgotPassword" component={ForgotPassword} />
            <Route exact path="/admin/verifyuser" component={VerifyUser} />
            <Route exact path="/admin/resetpassword" component={ResetPassword} />
            <Route exact path="/admin/criteriaeditor" component={CriteriaEditor} />

            <Route
              path="/admin"
              render={(routeProps) => (
                <OasdminContainer
                  {...routeProps}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                />
              )}
            />
          </Switch>
        </BrowserRouter>
      </div>
       <ApplicationFooter />
      <Loader />
      <SessionTimeOut {...props} />
    </div>
  );
};

export default AppLayout;
